(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  function updateMenus(root) {
    root.querySelectorAll('.ed-footer__menu').forEach((menu) => {
      menu.open = !mobile.matches;
      menu.querySelector('summary').tabIndex = mobile.matches ? 0 : -1;
    });
  }
  function initialize(scope) {
    scope.querySelectorAll('[data-ed-footer]').forEach((root) => {
      if (root.dataset.footerReady) return;
      root.dataset.footerReady = 'true';
      updateMenus(root);
    });
  }
  initialize(document);
  mobile.addEventListener('change', () => {
    document.querySelectorAll('[data-ed-footer]').forEach(updateMenus);
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
